import { Controller } from "@hotwired/stimulus"
import cytoscape from "cytoscape"

// Connects to data-controller="researcher-network"
export default class extends Controller {
  connect() {
    this.cy = cytoscape({
    })
  }

  disconnect() {
    this.cy?.destroy()
    this.cy = null
  }
}
